import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const inputCls = "rounded-lg w-full bg-white/5 border border-white/15 px-4 py-4 text-base text-white placeholder:text-white/35 focus:outline-none focus:border-primary transition-colors duration-300";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("is_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-background flex items-center justify-center px-5 grain relative">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md border border-white/10 bg-card rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.25)] p-8 md:p-10"
      >
        <img src="/logo.png" alt="Infinite Siding LLC" className="h-12 w-auto logo-on-dark mb-8" />
        <h1 className="font-display text-4xl tracking-wide flex items-center gap-3">
          ADMIN <Lock size={22} className="text-primary" aria-hidden="true" />
        </h1>
        <p className="text-white/50 text-sm mt-2 mb-8">Sign in to upload photos & videos and view quote requests.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="admin-email-input" className={inputCls} autoComplete="email" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-password-input" className={inputCls} autoComplete="current-password" />
          {error && <p data-testid="admin-login-error" className="text-red-400 text-sm">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-primary text-primary-foreground font-bold uppercase tracking-widest text-sm py-4 transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_10px_30px_rgba(193,214,46,0.35)] disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
